import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { bearingFrequencyCalculatorPageQueryOptions } from "~/app/api/pageData/bearingFrequencyCalculatorPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createBearingFrequencyCalculatorPage } from "~/pages/BearingFrequencyCalculatorPage/BearingFrequencyCalculatorPage";

function BearingFrequencyCalculatorRoute() {
  const result = useLoaderData({
    from: "/bearing-frequency-calculator",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createBearingFrequencyCalculatorPage()}
    </StorefrontShellFrame>
  );
}

export async function loadBearingFrequencyCalculatorPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(bearingFrequencyCalculatorPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const bearingFrequencyCalculatorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/bearing-frequency-calculator",
  loader: async ({ context }) => loadBearingFrequencyCalculatorPageData(context),
  component: BearingFrequencyCalculatorRoute,
});
